import React from 'react'
import { organizationsContext } from './context';
import { OrganizationsProvider } from './provider';

const useOrganizations = () => {
  const { organizations } = React.useContext(organizationsContext);
  return { organizations };
}

export { useOrganizations, OrganizationsProvider }
